import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import Flex from 'ui/Flex/Flex';

export const StyFilter = styled('fieldset', {
    name: 'StyFilter',
})(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '4px 8px',
    flexShrink: 0,
    border: `thin solid ${theme.palette.primary.main}`,
    borderRadius: '28px',
    height: '44px',
    width: 'fit-content',
}));

export const StyFilterLegend = styled('legend', {
    name: 'StyFilterLegend',
    shouldForwardProp: (prop) => prop !== 'hidden',
})<{ hidden: boolean }>(({ hidden }) => ({
    height: '15px',
    padding: hidden ? 0 : undefined,
}));

export const StyTypography = styled(Typography, {
    name: 'StyTypography',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    fontSize: '0.6rem',
}));

export const StyFilterContent = styled(Flex, {
    name: 'StyFilterContent',
})(() => ({
    justifyContent: 'right',
    width: '100%',
}));
